/* ══════════════════════════════════════════
   MOCK DATA — OPERATORE SANITARIO
   ══════════════════════════════════════════ */

export const profiloOperatore = {
  id: 'op-001',
  nome: 'Marco',
  cognome: 'Colombo',
  qualifica: 'Infermiere',
  qualificaBreve: 'Inf.',
  avatar: 'MC',
  matricola: 'INF-2024-0087',
  distretto: 'Distretto 2 - Roma Sud',
  provider: 'Coop. Cuore di San Camillo',
  turno: 'Mattina (06:00 - 14:00)',
};

export const statoConnessione = {
  online: true,
  ultimaSync: '07:45',
  paiSincronizzati: 12,
  paiTotali: 12,
};

const oggi = new Date();
const formatDate = (d) =>
  `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;

export const agendaOggi = [
  {
    id: 'vis-001',
    orarioInizio: '09:00',
    orarioFine: '09:45',
    stato: 'da-eseguire',
    paziente: {
      nome: 'Anna',
      cognome: 'Bianchi',
      eta: 82,
      codiceFiscale: 'BNCHNN44A41H501K',
      avatar: 'AB',
    },
    indirizzo: 'Via dei Giubbonari 28, sc. B, int. 4 - Roma',
    distanzaKm: 2.3,
    tempoStimato: '12 min',
    codicePAI: 'PAI-2026-00018',
    prestazioni: [
      { codice: 'INF-01', descrizione: 'Prelievo Ematico', icona: 'syringe' },
      { codice: 'INF-03', descrizione: 'Rilevazione Parametri Vitali', icona: 'heart-pulse' },
    ],
    note: 'Paziente allettata. Citofono rotto - chiamare al 338 221 4455.',
    priorita: 'normale',
  },
  {
    id: 'vis-002',
    orarioInizio: '10:15',
    orarioFine: '11:00',
    stato: 'da-eseguire',
    paziente: {
      nome: 'Giuseppe',
      cognome: 'Ferretti',
      eta: 75,
      codiceFiscale: 'FRRGPP51C12H501R',
      avatar: 'GF',
    },
    indirizzo: 'Viale Aventino 102, int. 7 - Roma',
    distanzaKm: 4.1,
    tempoStimato: '18 min',
    codicePAI: 'PAI-2026-00031',
    prestazioni: [
      { codice: 'INF-05', descrizione: 'Medicazione Lesione da Pressione', icona: 'bandage' },
      { codice: 'INF-07', descrizione: 'Educazione Terapeutica al Caregiver', icona: 'book-open' },
    ],
    note: 'Lesione sacrale stadio II. Caregiver presente (figlia).',
    priorita: 'alta',
  },
  {
    id: 'vis-003',
    orarioInizio: '11:30',
    orarioFine: '12:15',
    stato: 'da-eseguire',
    paziente: {
      nome: 'Maria Teresa',
      cognome: 'Conti',
      eta: 88,
      codiceFiscale: 'CNTMRT38E45H501F',
      avatar: 'MC',
    },
    indirizzo: 'Via Ostiense 234, piano 3 - Roma',
    distanzaKm: 5.8,
    tempoStimato: '22 min',
    codicePAI: 'PAI-2026-00045',
    prestazioni: [
      { codice: 'INF-02', descrizione: 'Somministrazione Terapia Endovenosa', icona: 'pill' },
      { codice: 'INF-01', descrizione: 'Prelievo Ematico', icona: 'syringe' },
      { codice: 'INF-03', descrizione: 'Rilevazione Parametri Vitali', icona: 'heart-pulse' },
    ],
    note: 'Accesso venoso periferico. Necessita accompagnamento scale (no ascensore).',
    priorita: 'alta',
  },
];

export const dataCorrente = formatDate(oggi);

export const riepilogoTurno = {
  visiteTotali: 3,
  visiteCompletate: 0,
  visiteInCorso: 0,
  visiteDaEseguire: 3,
  kmStimati: 12.2,
  tempoStimato: '3h 15min',
};

/* ══════════════════════════════════════════
   FASCICOLO PAZIENTE — Dati per la vista pre-visita
   ══════════════════════════════════════════ */

export const fascicoli = {
  'vis-001': {
    alertClinici: [
      { id: 'al-1', tipo: 'allergia', testo: 'ALLERGIE: Penicillina, Sulfamidici', severita: 'alta' },
      { id: 'al-2', tipo: 'rischio', testo: 'Rischio cadute elevato (Scala Morse: 55/125)', severita: 'media' },
    ],
    obiettivoPAI: 'Mantenimento stabilita clinica e monitoraggio parametri vitali post-intervento chirurgico (protesi anca dx, 12/01/2026).',
    prestazioniOggi: [
      { descrizione: 'Prelievo Ematico (emocromo + coagulazione)', codice: 'INF-01' },
      { descrizione: 'Rilevazione Parametri Vitali (PA, FC, SpO2, TC)', codice: 'INF-03' },
    ],
    diarioCondiviso: [
      {
        id: 'dc-1',
        data: 'Ieri, 15:00',
        operatore: 'Giulia Santini',
        qualifica: 'OSS',
        avatar: 'GS',
        nota: 'Paziente ha pranzato regolarmente. Igiene personale effettuata a letto. Nessuna lamentela particolare. Umore buono.',
      },
      {
        id: 'dc-2',
        data: '2 giorni fa, 10:30',
        operatore: 'Luca Parisi',
        qualifica: 'Fisioterapista',
        avatar: 'LP',
        nota: 'Eseguiti esercizi di deambulazione assistita (15 min). Lieve affaticamento al termine. Progressi nella mobilizzazione attiva. Si consiglia continuare con 2 sessioni/settimana.',
      },
      {
        id: 'dc-3',
        data: '3 giorni fa, 09:15',
        operatore: 'Marco Colombo',
        qualifica: 'Infermiere',
        avatar: 'MC',
        nota: 'Prelievo ematico eseguito. PA 135/82 mmHg, FC 74 bpm, SpO2 96%, TC 36.4. Valori nella norma. Riferita lieve cefalea mattutina, risoltasi spontaneamente.',
      },
    ],
    mmgRiferimento: 'Dott. Franco Rinaldi',
    caseManager: 'Dott.ssa Elena Vespri',
    dataAttivazionePAI: '15/01/2026',
    scadenzaPAI: '15/07/2026',
  },
  'vis-002': {
    alertClinici: [
      { id: 'al-3', tipo: 'allergia', testo: 'ALLERGIE: Lattice', severita: 'alta' },
      { id: 'al-4', tipo: 'attenzione', testo: 'ATTENZIONE: Paziente diabetico (Tipo 2) - Controllare glicemia', severita: 'media' },
      { id: 'al-5', tipo: 'rischio', testo: 'Lesione da pressione sacrale Stadio II attiva', severita: 'alta' },
    ],
    obiettivoPAI: 'Guarigione lesione da pressione sacrale e prevenzione recidive. Educazione terapeutica al caregiver per gestione domiciliare.',
    prestazioniOggi: [
      { descrizione: 'Medicazione avanzata lesione sacrale (detersione + collagene)', codice: 'INF-05' },
      { descrizione: 'Educazione terapeutica al caregiver (posizionamento, superfici antidecubito)', codice: 'INF-07' },
    ],
    diarioCondiviso: [
      {
        id: 'dc-4',
        data: 'Ieri, 11:00',
        operatore: 'Marco Colombo',
        qualifica: 'Infermiere',
        avatar: 'MC',
        nota: 'Medicazione eseguita. Lesione 3x2cm, fondo fibrinoso al 30%, margini arrossati. Applicato collagene. Prossimo controllo tra 48h.',
      },
      {
        id: 'dc-5',
        data: '3 giorni fa, 14:30',
        operatore: 'Anna Ferri',
        qualifica: 'OSS',
        avatar: 'AF',
        nota: 'Igiene effettuata. Cambio posturale ogni 2 ore rispettato. La figlia riferisce miglioramento dolore.',
      },
    ],
    mmgRiferimento: 'Dott.ssa Maria Luisa Conti',
    caseManager: 'Dott.ssa Elena Vespri',
    dataAttivazionePAI: '01/02/2026',
    scadenzaPAI: '01/08/2026',
  },
  'vis-003': {
    alertClinici: [
      { id: 'al-6', tipo: 'allergia', testo: 'ALLERGIE: Nessuna allergia nota', severita: 'bassa' },
      { id: 'al-7', tipo: 'rischio', testo: 'ATTENZIONE: Rischio cadute elevato - No ascensore, 3 piano', severita: 'alta' },
      { id: 'al-8', tipo: 'attenzione', testo: 'Paziente con accesso venoso periferico - Verificare pervietà', severita: 'media' },
    ],
    obiettivoPAI: 'Completamento ciclo terapia endovenosa antibiotica (Ceftriaxone 2g/die x 14gg) e monitoraggio funzionalita renale.',
    prestazioniOggi: [
      { descrizione: 'Somministrazione Terapia Endovenosa (Ceftriaxone 2g in 100ml SF)', codice: 'INF-02' },
      { descrizione: 'Prelievo Ematico (creatinina, azotemia, emocromo)', codice: 'INF-01' },
      { descrizione: 'Rilevazione Parametri Vitali (PA, FC, SpO2, TC)', codice: 'INF-03' },
    ],
    diarioCondiviso: [
      {
        id: 'dc-6',
        data: 'Ieri, 11:45',
        operatore: 'Marco Colombo',
        qualifica: 'Infermiere',
        avatar: 'MC',
        nota: 'Terapia EV somministrata senza reazioni avverse. Accesso venoso pervio. PA 128/76, FC 68, SpO2 97%, TC 36.8. Giorno 10/14 del ciclo.',
      },
      {
        id: 'dc-7',
        data: '2 giorni fa, 16:00',
        operatore: 'Rosa Benedetti',
        qualifica: 'OSS',
        avatar: 'RB',
        nota: 'Assistenza alla deambulazione fino al bagno. Paziente collaborante ma affaticata. Pasto serale consumato parzialmente.',
      },
      {
        id: 'dc-8',
        data: '4 giorni fa, 10:00',
        operatore: 'Luca Parisi',
        qualifica: 'Fisioterapista',
        avatar: 'LP',
        nota: 'Valutazione funzionale: deambulazione con ausilio (deambulatore). Equilibrio instabile. Programma esercizi consegnato alla nipote.',
      },
    ],
    mmgRiferimento: 'Dott. Alessandro Moretti',
    caseManager: 'Dott.ssa Elena Vespri',
    dataAttivazionePAI: '20/02/2026',
    scadenzaPAI: '20/03/2026',
  },
};
